/**
 * This file produces the .js preload that finsemble loads when running in desktop mode (under FEA).
 * This file is webpacked into a "UMD" file which just means that it can be run directly in a browser page.
 * The FSBL object will be loaded into the global namespace (window).
 *
 */

import { unhandledErrors } from "./unhandledErrors";
import { Globals } from "../../common/Globals";
import { FSBLDesktop } from "./FSBLDesktop";
import { FinsembleDesktopAgent } from "../Interop/FinsembleDesktopAgent";
import { RouterClient } from "../routerClient";
import { Startup } from "../Startup/Startup";
import { DesktopAgent } from "@finos/fdc3";
import { Logger } from "../logger";

if (Globals.FSBL) {
	console.warn(
		"FSBL.js - Global object FSBL already exists (window.FSBL). Was finsemble-desktop-api-preload.js imported twice?"
	);
}

/**
 * Starts the Finsemble API in desktop (FEA) mode. The FSBL object will fetch config using `fin.getOptions` and
 * use that information to bootstrap a router connection and obtain startup information. This will result
 * in a live API that will trigger a FSBLReady window event once the router is running.
 *
 * fdc3 is immediately ready for use (it employs queuing until connected).
 */
const main = async () => {
	unhandledErrors();
	Logger.system.debug("finsemble-desktop-api-preloads main before new FinsembleDesktopAgent");

	const fdc3 = new FinsembleDesktopAgent({
		routerClient: RouterClient,
		startup: Startup.getInstance(),
	});

	Globals.fdc3 = <DesktopAgent>fdc3;
	(Globals.fin as any).log("finsemble-desktop-api-preloads main before new FSBLDesktop");
	Logger.system.debug("finsemble-desktop-api-preloads main before new FSBLDesktop");
	Globals.FSBL = new FSBLDesktop({ fdc3 });
	Logger.system.debug("finsemble-desktop-api-preloads main before Globals.FSBL.startApp()");
	await Globals.FSBL.startApp();

	/**
	 * Cleans up when the browser page closes.
	 */
	window.addEventListener("unload", () => {
		// fdc3.stop() must be called before Globals.FSBL.stopApp(). If not, the router is disconnected and
		// deregistration does not happen correctly.
		fdc3.stop();
		Globals.FSBL.stopApp();
	});
};

main();
